/* Sesami renders its "Choose a date & time" button inside an open shadow root (Lit, inline styles),
   so theme CSS can't reach it. Adopt a sheet that matches the OSO CTA system (ink block, 12px tracked
   caps, gold seam that runs the width on hover). !important beats Sesami's inline styles. */
(() => {
  if (window.osoSesamiCta) return;
  window.osoSesamiCta = true;

  const css = `
    button.sesami-calendar{
      position:relative;overflow:hidden;isolation:isolate;box-sizing:border-box;
      min-height:55px !important;height:auto !important;padding:15px 26px 17px !important;
      font-family:var(--text-font-family, inherit) !important;font-size:12px !important;font-weight:500 !important;
      letter-spacing:.16em !important;text-transform:uppercase !important;line-height:1.2;
      color:#f5f1e9 !important;background:#29251f !important;border:1px solid #29251f !important;border-radius:0 !important;
      transition:background-color .5s cubic-bezier(.19,1,.22,1),border-color .5s cubic-bezier(.19,1,.22,1);
    }
    button.sesami-calendar::after{
      content:"";position:absolute;left:26px;bottom:9px;width:22px;height:1px;
      background:linear-gradient(90deg,#c9a463,#e5c78f 50%,#c9a463);
      transition:width .8s cubic-bezier(.19,1,.22,1),left .8s cubic-bezier(.19,1,.22,1);
    }
    button.sesami-calendar:enabled:hover{background:#464035 !important;border-color:#464035 !important}
    button.sesami-calendar:enabled:hover::after{left:0;width:100%}
    button.sesami-calendar:focus-visible{outline:2px solid #806d50;outline-offset:3px}
    button.sesami-calendar[disabled]::after{opacity:.35}
  `;
  let sheet = null;
  try { sheet = new CSSStyleSheet(); sheet.replaceSync(css); } catch (e) { sheet = null; }

  const style = (el) => {
    const root = el.shadowRoot;
    if (!root || root.__osoCta) return !!root;
    if (sheet && 'adoptedStyleSheets' in root) {
      root.adoptedStyleSheets = [...root.adoptedStyleSheets, sheet];
    } else {
      const tag = document.createElement('style');
      tag.textContent = css;
      root.appendChild(tag);
    }
    root.__osoCta = true;
    return true;
  };

  const run = () => document.querySelectorAll('sesami-experience').forEach((el) => {
    if (style(el)) return;
    let tries = 0;
    const t = setInterval(() => { if (style(el) || ++tries > 40) clearInterval(t); }, 100);
  });

  if (window.customElements) customElements.whenDefined('sesami-experience').then(run);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();
